import React, { useState } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import Input from "../../elements/input";
import Modal from "../../components/Modal";
import BodyText from "../../elements/body-text";
import "./style.scss";
import VerifyEmailForm from "../../sections/verify-email-form";
import api from "../../utils/api";
import { SuperButton } from "../../elements";
import { getEncryptor } from "../../services/siteService";
import { updateEmail } from "../../services/userService";
import { codeTypes } from "../../utils/lynkco-constants";
import ChangeEmailVerifyPassword from "../change-email-verify-password";

function ChangeEmailModal({ emailEntered, user, open, fields, onCloseClicked, onUpdateSuccess, onForgetPassword }) {
  const { headingTypeCode, headingBodyCode, verifyEmailForm } = fields;
  const [passwordIsVerified, setPasswordIsVerified] = useState(false);
  const [emailUpdateFailed, setEmailUpdateFailed] = useState(false);
  const [sendCodeFailed, setSendCodeFailed] = useState(false);

  const modalProps = {
    showModal: open,
    onCloseClicked: evt => {
      onCloseClicked && onCloseClicked(evt);
    }
  };
  const changeEmailVerifyPasswordProps = {
    user,
    fields: fields,
    visible: !passwordIsVerified,
    emailEntered,
    onForgetPassword,
    onPasswordVerified: () => {
      setPasswordIsVerified(true);
    },
    onSendCodeFailed: () => {
      setSendCodeFailed(true);
    }
  };
  const verifyEmailProps = {
    ...verifyEmailForm[0].fields,
    submittedEmail: emailEntered,
    codeType: codeTypes.updateEmail,
    sendCodeFailed,
    submitFailed: emailUpdateFailed,
    onVerificationCodeSubmitted: async (evt, data) => {
      try {
        await updateEmail(user.userAccount, user.email, emailEntered, data.code);
        // console.log("onUpdateSuccess", onUpdateSuccess);
        onUpdateSuccess && onUpdateSuccess();
      } catch (ex) {
        console.log("ex", ex);
        setEmailUpdateFailed(true);
      }
    }
  };
  return (
    <Modal className="change-email-modal" {...modalProps}>
      {/* Enter password step */}
      <ChangeEmailVerifyPassword {...changeEmailVerifyPasswordProps} />
      {/* Enter verification code step */}
      {passwordIsVerified && (
        <React.Fragment>
          <Heading type={headingTypeCode} html={headingBodyCode} className="change-email-modal-heading" typographyClass="type-h1" />
          <VerifyEmailForm {...verifyEmailProps} />
        </React.Fragment>
      )}
    </Modal>
  );
}
export default ChangeEmailModal;
// ChangeEmailModal.propTypes = {
//   userIsVerified: PropTypes.bool,
//   enterPasswordStep: PropTypes.shape({
//     heading: PropTypes.shape({
//       type: PropTypes.string,
//       className: PropTypes.string,
//       /** This takes the component is RTF */
//       html: PropTypes.string
//     }),
//     subHeading: PropTypes.shape({
//       type: PropTypes.string,
//       className: PropTypes.string,
//       html: PropTypes.string
//     }),
//     body: PropTypes.string,
//     button: PropTypes.shape({
//       callback: PropTypes.func,
//       icon: PropTypes.shape({ svg: PropTypes.string }),
//       colorScheme: PropTypes.string,
//       width: PropTypes.string,
//       isDisabled: PropTypes.bool,
//       internalLink: PropTypes.any,
//       transition: PropTypes.any,
//       buttonText: PropTypes.string
//     }),
//     input: PropTypes.shape({
//       pattern: PropTypes.string,
//       infoMessage: PropTypes.string,
//       warningMessage: PropTypes.string,
//       value: PropTypes.string,
//       type: PropTypes.string,
//       onBlur: PropTypes.func,
//       onChange: PropTypes.func,
//       onFocus: PropTypes.func,
//       hasError: PropTypes.bool
//     }),
//     link: PropTypes.shape({
//       internalLink: PropTypes.string,
//       buttonText: PropTypes.string.isRequired,
//       externalLink: PropTypes.string,
//       className: PropTypes.string
//     }),
//     disclaimer: PropTypes.shape({
//       body: PropTypes.any
//     }),
//     serverError: PropTypes.shape({
//       hasError: PropTypes.bool,
//       message: PropTypes.string
//     })
//   }),
//   enterVerificationCodeStep: PropTypes.object
// };
